<template>
  <el-dropdown
    trigger="click"
    @command="handleActionClicked"
    v-show="showActionDropdown"
    v-test-id="'action-dropdown'"
    data-element="action"
  >
    <fa-icon
      size="sm"
      class="u-icon--light u-link"
      icon="ellipsis-v"
      @click.stop=""
    />
    <el-dropdown-menu
      slot="dropdown"
      data-element="action-dropdown-menu"
    >
      <template v-for="item in activeActionItems">
        <el-dropdown-item
          v-test-id="`${item.name}-action-button`"
          :key="item.name"
          :command="item.action"
        >
          {{ item.label }}
        </el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {isEmpty} from 'lodash'

export default {
  name: 'NoteCardActionsPopover',
  data () {
    return {
      actionItems: [
        {
          name: 'edit',
          label: 'Edit',
          action: () => {
            this.$emit('edit-note-click')
          },
          isActive: this.editable
        },
        {
          name: 'delete',
          label: 'Archive',
          action: () => {
            this.$emit('delete-note-click')
          },
          isActive: this.deletable
        }
      ]
    }
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleActionClicked (cmd) {
      cmd()
    }
  },
  computed: {
    activeActionItems () {
      return this.actionItems.filter(item => item.isActive)
    },
    showActionDropdown () {
      return !isEmpty(this.activeActionItems)
    }
  }
}
</script>
